module.exports = __webpack_public_path__ + "img/pennine-drive.4181c18d.png";